<template>
  <div
    v-loading.lock="loading"
    :element-loading-text="$t('connecting')"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    class="overflow-hidden flex flex-col items-center"
  >
    <div class="flex items-center flex-wrap lg:flex-nowrap">
      <div v-if="mini">
        <div class="bg-white rounded-lg py-1 px-2">
          <p
            v-for="(label, index) in labels"
            :key="index"
            class="flex items-center gap-2"
          >
            <span
              class="h-2 w-4 rounded "
              :style="{ background: options.colors[index] }"
            ></span>
            {{ formatNumber(series[index]) }}
          </p>
        </div>
      </div>
      <div class="mx-auto">
        <apexchart
          ref="chart"
          type="donut"
          :width="width"
          :options="options"
          :series="series"
        >
        </apexchart>
      </div>
    </div>
    <table v-if="labelShow && !mini">
      <tr v-if="labels.length">
        <td></td>
        <td class="text-right px-2 sm:px-6">
          <IconNumber
            class="text-indigo-800 ml-auto mb-2"
            style="width: 24px; height: 24px"
          />
        </td>
        <td class="text-right">
          <IconPercent class="text-cyan-800 ml-auto mb-2" />
        </td>
      </tr>
      <tr v-for="(label, index) in labels" :key="index">
        <td>
          <div class="flex items-center">
            <div>
              <span
                class="rounded inline-block mr-2.5 w-5 h-3 sm:w-8 sm:h-4"
                :style="{ background: options.colors[index] }"
              ></span>
            </div>
            <p class="text-sm sm:text-lg leading-snug font-bold text-slate-500">
              {{ label }}
            </p>
          </div>
        </td>
        <td class="text-right px-2 sm:px-6">
          <p
            class="text-base sm:text-2xl leading-snug font-bold whitespace-nowrap"
            :style="{ color: numberColors[index] }"
          >
            {{ formatNumber(series[index]) }}
          </p>
        </td>
        <td class="text-right">
          <p
            class="text-base sm:text-2xl leading-snug font-bold text-cyan-600 whitespace-nowrap"
          >
            {{ (Math.round((series[index] / seriesTotals) * 100) || 0) + "%" }}
          </p>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import IconNumber from "./Icons/iconNumber.vue";
import IconPercent from "./Icons/iconPercent.vue";

export default {
  name: "PieChart",
  components: {
    IconNumber,
    IconPercent,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [String, Number],
      default: "400",
    },
    labels: {
      type: Array,
      default: () => [],
    },
    series: {
      type: Array,
      default: () => [],
    },
    colors: {
      type: Array,
      default: () => ["#2DD4BF", "#FED7AA", "#FB7185"],
    },
    numberColors: {
      type: Array,
      default: () => ["#059669", "#F59E0B", "#E11D48"],
    },
    labelShow: {
      type: Boolean,
      default: true,
    },
    totalFontSize: {
      type: String,
      default: "14px",
    },
    valueFontSize: {
      type: String,
      default: "32px",
    },
    mini: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    options() {
      return {
        labels: this.labels,
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 90,
            donut: {
              labels: {
                show: true,
                name: {
                  offsetY: -30,
                },
                value: {
                  show: true,
                  fontSize: this.valueFontSize,
                  fontWeight: "700",
                  color: "#3730A3",
                  offsetY: -10,
                  formatter: function(val) {
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                  },
                },
                total: {
                  showAlways: true,
                  show: true,
                  label: this.$t("total"),
                  fontSize: this.totalFontSize,
                  fontWeight: 500,
                  color: "#615E83",
                  formatter: function(w) {
                    return w.globals.seriesTotals
                      .reduce((a, b) => a + b, 0)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                  },
                },
              },
            },
          },
        },
        grid: {
          padding: {
            bottom: this.mini ? -100 : -120,
          },
        },
        states: {
          hover: {
            filter: { type: "none" },
          },
          active: {
            filter: { type: "none" },
          },
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        colors: this.colors,
        chart: {
          fontFamily: '"Nunito", sans-serif',
        },
        stroke: {
          colors: "#f1f5f9",
          width: 3,
        },
        tooltip: {
          enabled: true,
          theme: "dark",
          fillSeriesColor: false,
          style: {
            fontSize: "12px",
            color: "#000",
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: this.mini ? "100%" : 300,
                height: 300,
              },
            },
          },
        ],
      };
    },
    seriesTotals() {
      return this.series.reduce((a, b) => a + b, 0);
    },
  },
  methods: {
    formatNumber(num) {
      if (!num) return "0";
      // Raqamga aylantirish
      const number = parseInt(num);
      if (isNaN(number)) return num;

      // 3 xonadan bo'lib, bo'shliq bilan ajratish
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
};
</script>

<style lang="scss" scoped></style>
